<template>
  <div class="container">
    <PublicHeader :totalName="$t('finance').orderDetails" />
    <div class="orderInfo">
      <div class="name">{{ orderInfo.name }}</div>
      <div class="time">{{ $t('finance').Subscriptiondate }}：{{ orderInfo.applyTime | getLocalTime }}</div>
      <div class="time" v-if="orderInfo.status==1">{{ $t('finance').duedate }}：{{ orderInfo.maturityTime | getLocalTime }}</div>
      <div class="time" v-if="orderInfo.status==3">{{ $t('finance').duedate }}：{{ $t('c2c').Completed }}</div>
      <div class="yieldInfo" v-if="orderInfo.status==1">
        <div class="txtss"><span>{{$t('finance').investment}}</span><span>{{$t('finance').EstimatedReturn}}</span></div>
        <div class="num"><span>{{ orderInfo.amount }} USDT</span><span>{{ (orderInfo.amount*orderInfo.yieldMin/100*orderInfo.yieldDays).toFixed(6).replace(/\.?0+$/, '') }} USDT</span></div>
      </div>
      <div class="yieldInfo" v-if="orderInfo.status==3">
        <div class="txtss"><span>{{$t('finance').investment}}</span><span>{{$t('finance').yieldmaturity}}</span></div>
        <div class="num"><span>{{ orderInfo.amount }} USDT</span><span>{{ orderInfo.revenueAmount }} USDT</span></div>
      </div>
    </div>
    <!-- 列表 -->
    <div class="listInfo">
      <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText" @load="getAssetChangeLog" :immediate-check="false">
        <div class="item" v-for="(dItem, dIndex) in oList" :key="`fiorderino${dIndex}`">
          <div class="left">
            <div class="txt">{{$t('finance').Dailyearnings}}</div>
            <div class="time">{{dItem.operTime | getLocalTime}}</div>
          </div>
          <div class="right">+{{dItem.amount}} USDT</div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import PublicHeader from '@/components/publicHeader'
import orderApi from '@/api/order'
import userApi from '@/api/user'
export default {
  components: {
    PublicHeader
  },
  data() {
    return {
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 15,
        assetType: '5',
        currency: 'USDT',
        businessName: 'finance_income',
      },
      oList: [],
      financingOrderId: null,
      orderInfo: {},
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.financingOrderId = this.$route.query.id
      this.getFinanceOrderInfo()
    }
  },
  methods: {
    // 详情
    async getFinanceOrderInfo() {
      const res = await orderApi.getFinanceOrderInfo({ financingOrderId: this.financingOrderId })
      this.orderInfo = res.data
      this.getAssetChangeLog()
    },
    // 获取收益记录
    async getAssetChangeLog() {
      if (this.isRun) return
      this.isRun = true
      this.parms.tradeId = this.financingOrderId
      const res = await userApi.getAssetChangeLog(this.parms)
      this.oList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.oList.length >= res.total)
        this.finished = true;
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);
  padding-top: 40px;
  padding-bottom: 30px;

  .orderInfo {
    padding: 15px;
    border-bottom: 1px solid var(--info_color);

    .name {
      font-size: 16px;
      color: var(--text_color);
    }

    .time {
      margin-top: 15px;
      font-size: 13px;
      color: var(--ntext_color);
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .yieldInfo {
      margin-top: 15px;
      background: var(--info_color);
      padding: 15px;
      border-radius: 5px;

      .txtss {
        font-size: 12px;
        color: var(--ntext_color);
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .num {
        margin-top: 15px;
        font-size: 12px;
        color: var(--text_color);
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
  }

  .listInfo {
    .item {
      padding: 15px 30px;
      border-bottom: 1px solid var(--info_color);
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        .txt {
          font-size: 13px;
          color: var(--text_color);
        }

        .time {
          margin-top: 10px;
          font-size: 13px;
          color: var(--ntext_color);
        }
      }
      .right {
        font-size: 15px;
        color: var(--text_color);
      }
    }
  }
}
</style>
